<template>
  <div class="fan fan-component">
    <!-- 查看/禁用模式：纯图片展示 -->
    <div v-if="disabled" class="images-view-mode" style="display:flex;gap:8px;flex-wrap:wrap;">
      <a-image
        v-for="(url, idx) in parsedUrls"
        :key="idx"
        width="80"
        height="80"
        :src="url"
        fit="cover"
        style="border-radius: 8px; cursor: pointer;"
      />
    </div>
    <span v-else-if="disabled && !parsedUrls.length" style="color:#c0c4cc;">暂无</span>

    <!-- 编辑/新增模式：上传组件 -->
    <a-upload v-else-if="name"
              :action="upUrl"
              :multiple="true"
              :headers="headers"
              list-type="picture-card"
              :file-list="fileList"
              @preview="bindImgsPreview"
              @change="bindImgsUpload" >
      <div v-if="fileList.length < limit">
        <icon-plus />
        <div>上传</div>
      </div>
    </a-upload>
    <a-modal :visible="!!previewImg" :footer="false" @cancel="bindImgsPreviewCancle">
      <img style="width:100%" :src="previewImg" />
    </a-modal>
  </div>
</template>

<script>
const env = require("../../../env/index");
import { IconPlus } from '@arco-design/web-vue/es/icon'

export default {
  name: "ZUploadImages",
  components: { IconPlus },
  props: {
    name: String,
    value: [String, Array],
    disabled: Boolean,
    limit: { type: Number, default: 8 }
  },
  computed: {
    parsedUrls() {
      if (Array.isArray(this.value)) return this.value.filter(v => v && typeof v === 'string')
      if (!this.value) return []
      if (typeof this.value === 'string') {
        if (this.value.indexOf('http') === 0) return [this.value]
        try { const p = JSON.parse(this.value); return Array.isArray(p) ? p.filter(v => v) : [] }
        catch { return [] }
      }
      return []
    }
  },
  watch: {
    value(newValue) {
      if (newValue !== this._lastEmitValue) {
        this.fileList = this.initFileList(newValue);
        this.syncNewValue(newValue);
      }
    },
  },
  created() {
    this.fileList = this.initFileList(this.value);
    this.syncNewValue(this.value);
    this._lastEmitValue = null;
  },
  methods: {
    syncNewValue(value) {
      if (Array.isArray(value)) {
        this.newValue = [...value];
      } else if (typeof value === 'string' && value) {
        try { this.newValue = JSON.parse(value); }
        catch { this.newValue = value ? [value] : []; }
      } else {
        this.newValue = [];
      }
    },
    initFileList(value) {
      let arr = []
      if (Array.isArray(value) && value.length > 0) {
        arr = value.map((val, index) => ({
          uid: '-' + (index + 1),
          name: val.split('/').pop() || '图片',
          url: val,
          status: "done",
        }));
      } else if (value && typeof value === "string" && value !== "") {
        try {
          const parsed = JSON.parse(value)
          arr = Array.isArray(parsed) ? parsed.map((val, i) => ({
            uid: '-' + (i + 1),
            name: val.split('/').pop() || '图片',
            url: val,
            status: "done",
          })) : [{
            uid: '-1',
            name: value.split('/').pop() || '图片',
            url: value,
            status: "done",
          }]
        } catch {
          arr = [{ uid: '-1', name: value, url: value, status: "done" }]
        }
      }
      return arr;
    },
    bindImgsUpload(info, file) {
      // Arco @change 签名: (info, file) 其中 info 可能为 {file, fileList} 或直接是 fileItem
      // 安全提取 fileList
      let list = []
      if (info && Array.isArray(info.fileList)) {
        list = info.fileList
      } else if (Array.isArray(file)) {
        list = file
      } else if (Array.isArray(info)) {
        // 某些场景下 info 直接就是数组
        list = info
      }

      // 只有确认拿到合法数组才更新
      if (Array.isArray(list)) {
        this.fileList = list
      }

      // 从当前 fileList 提取所有 done 状态的 URL
      const urls = []
      for (const f of this.fileList) {
        if (!f) continue
        if (f.status === 'done') {
          const u = f.response ? f.response.data : (f.url || '')
          if (u) urls.push(u)
        }
      }
      this.newValue = urls
      this._lastEmitValue = urls
      this.$emit('change', this.name, this.newValue);
    },
    bindImgsPreview(file) {
      this.previewImg = file.url || file.name || '';
    },
    bindImgsPreviewCancle() {
      this.previewImg = '';
    }
  },
  data() {
    return {
      upUrl: env.UPLOAD,
      headers: { token: JSON.stringify(Object.assign(env.TOKEN, { token: this.$fan?.getToken() || '' })) },
      previewImg: '',
      fileList: [],
      newValue: [],
      _lastEmitValue: null
    };
  },
};
</script>

<style scoped>
</style>
